export const convertLocationToPath = (path: string) => {
    const match = path.match(/^([^.]*)/);

    return match && match.length > 1 ? match[1] : null;
};
